import { jsxs, jsx } from 'react/jsx-runtime';
import '../Arrow/index.js';
import { StyledLink, StyledResponsiveImage, Title, Description, ReadMore } from './BlogPost.styles.js';
import '../../hooks/index.js';
import { useTrackEventInView } from '../../hooks/useTrackEventInView.js';
import { useTrackEvent } from '../../hooks/useTrackEvent.js';
import Arrow from '../Arrow/Arrow.js';

/**
 *
 * BlogPost
 *
 * This components renders the items for the "Stories from the Community"  section
 * in the Discover page.
 */
const BlogPost = ({ image, title, content, links }) => {
    // Analytics
    const { ref } = useTrackEventInView('DISCOVER - Blog Post', {
        type: 'load',
        target: title,
    });
    const { trackEvent } = useTrackEvent();
    const link = links === null || links === void 0 ? void 0 : links[0];
    return (jsxs(StyledLink, Object.assign({ target: "_blank", variant: "secondary", href: link === null || link === void 0 ? void 0 : link.url, external: true, isUnderlined: true, onClick: () => 
        // FIXME: It's not dynamic, it's tight to the current content.
        trackEvent('DISCOVER - Blog Post', {
            type: 'click',
            target: title,
        }) }, { children: [jsx(StyledResponsiveImage, { image: image, withSkeletonUI: true }), jsx(Title, Object.assign({ ref: ref }, { children: title })), jsx(Description, { children: content }), jsxs(ReadMore, { children: [link === null || link === void 0 ? void 0 : link.text, jsx(Arrow, {})] })] })));
};

export { BlogPost as default };
